import React from 'react';
import { getTimeFormatted } from '../../utils/timeFormatted';

const Tooltip = (props) => (
  <div className={`relative group cursor-pointer ${props.className}`}>
    {props.children}
    <div className='absolute z-10 hidden px-1 text-sm text-white bg-gray-600 rounded group-hover:block top-2/3 whitespace-nowrap'>
      {props.title}
    </div>
  </div>
);

const battery = (level, time, t) => {
  // Define the battery level thresholds and corresponding SVG icons
  const batteryLevels = [
    { max: 20, icon: 'battery10' },
    { max: 40, icon: 'battery25' },
    { max: 50, icon: 'battery50' },
    { max: 70, icon: 'battery50' },
    { max: 80, icon: 'battery75' },
    { max: 90, icon: 'battery75' },
    { max: Infinity, icon: 'battery100' },
  ];

  // Find the appropriate battery icon based on the level
  const batteryIcon = batteryLevels.find(({ max }) => level <= max)?.icon;

  // Return the Tooltip component with the correct battery icon
  return (
    <Tooltip
      title={`${level}% (${t('since')} ${getTimeFormatted(time, t)})`}
      className='relative ml-2 w-2.5 h-auto'
    >
      <svg viewBox='0 0 10 22' width='10' height='20'>
        <use xlinkHref={`/images/battery.svg#${batteryIcon}`} />
      </svg>
    </Tooltip>
  );
};

// const battery = (level, time, t) => {
//   let result = '';
//   if (level > 0 && level <= 20) {
//     result = (
//       <Tooltip title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}>
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery10`} />
//         </svg>
//       </Tooltip>
//     );
//   } else if (level > 20 && level <= 40) {
//     result = (
//       <Tooltip
//         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}
//         className='relative ml-2 w-2.5 h-auto'
//       >
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery25`} />
//         </svg>
//       </Tooltip>
//     );
//   } else if (level > 40 && level <= 50) {
//     result = (
//       <Tooltip
//         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}
//         className='relative ml-2 w-2.5 h-auto'
//       >
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery50`} />
//         </svg>
//       </Tooltip>
//     );
//   } else if (level > 50 && level <= 70) {
//     result = (
//       <Tooltip
//         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}
//         className='relative ml-2 w-2.5 h-auto'
//       >
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery50`} />
//         </svg>
//       </Tooltip>
//     );
//   } else if (level > 70 && level <= 80) {
//     result = (
//       <Tooltip
//         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}
//         className='relative ml-2 w-2.5 h-auto'
//       >
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery75`} />
//         </svg>
//       </Tooltip>
//     );
//   } else if (level > 80 && level <= 90) {
//     result = (
//       <Tooltip
//         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}
//         className='relative ml-2 w-2.5 h-auto'
//       >
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery75`} />
//         </svg>
//       </Tooltip>
//     );
//   } else if (level > 90) {
//     result = (
//       <Tooltip
//         title={level + '%' + ` (${t('since')} ` + getTimeFormatted(time, t) + ')'}
//         className='relative ml-2 w-2.5 h-auto'
//       >
//         <svg viewBox='0 0 10 22' width='10' height='20'>
//           <use xlinkHref={`/images/battery.svg#battery100`} />
//         </svg>
//       </Tooltip>
//     );
//   }
//   return result;
// };

const ChipDevice = (props) => (
  <div className='relative px-4 py-1 text-sm font-normal text-chip rounded-3xl bg-light-info h-7 w-max'>
    <div className='flex'>
      <div>{props.children}</div>
      {!props.isEmergency ? (
        <div>
          {props.status === 'ACTIVATE_OFF' ||
          (!props.action && props.status === 'ACTIVATE_ON') ||
          (props.action &&
            ((props.action.alerts && props.action.alerts.find((a) => a.alertType === 504 || a.alertType === 513)) ||
              props.action.nosignal === 'true' ||
              (props.action.changed && props.action.changed.a === null && props.status === 'ACTIVATE_ON'))) ? (
            <Tooltip
              title={`${props.t('since')} ${getTimeFormatted(props.action && props.action.timestamp, props.t)}`}
              className='w-5.2 h-auto ml-2'
            >
              <svg viewBox='0 0 30 27' width='20' height='20'>
                <use xlinkHref={`/images/signal.svg#badsignal`} />
              </svg>
            </Tooltip>
          ) : props.action && props.level ? (
            battery(
              props.level,
              props.action.batteryTimestamp ? props.action.batteryTimestamp : props.action.timestamp,
              props.t,
            )
          ) : (
            <Tooltip
              title={getTimeFormatted(props.action && props.action.timestamp, props.t)}
              className='w-5 h-auto ml-2 mr-1'
            >
              <svg viewBox='0 0 30 27' width='20' height='20'>
                <use xlinkHref={`/images/signal.svg#goodsignal`} />
              </svg>
            </Tooltip>
          )}
        </div>
      ) : (
        <div>
          {props.action && props.isShowBattery
            ? battery(
                props.level,
                props.action.batteryTimestamp ? props.action.batteryTimestamp : props.action.timestamp,
                props.t,
              )
            : ''}
        </div>
      )}
    </div>
  </div>
);

export default ChipDevice;
